/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import moment from 'moment';

import { connectRequests } from '../../../higherOrderComponents/requests';

export default connectRequests((state, props) => ({
  maintenances: {
    url: `/maintenances?instance=${props.instanceKey}&locale=en&&startTime=${moment().subtract(2, 'month').startOf('month').format('YYYY-MM-DD')}`,
    responseAlias: 'rows',
    onLoad: true,
  }
}));
